import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Realisations from "./pages/Realisations";
import Services from "./pages/Services";
import Faq from "./pages/Faq";
import ScrollToTop from "./components/ScrollToTop";
import Confidentialite from "./pages/Confidentialite";
import Mentions from "./pages/Mentions";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/realisations" element={<Realisations />} />
          <Route path="/services" element={<Services />} />
          <Route path="/faq" element={<Faq />} />
          <Route
            path="/politique-de-confidentialite"
            element={<Confidentialite />}
          />
          <Route path="/mentions-legales" element={<Mentions />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
